import { addAPIProvider } from '@iconify/vue';

/** Setup the iconify offline */
export function setupIconifyOffline() {
	const { VITE_ICONIFY_URL } = import.meta.env;

	if (VITE_ICONIFY_URL) {
		addAPIProvider('', { resources: [VITE_ICONIFY_URL] });

		// Note: disableCache is deprecated. Modern Iconify versions handle caching automatically.
		// If explicit cache control is needed, configure it through the API provider options.
	}
}
